import laptops from "./laptops";
import desktops from "./desktops";
import phones from "./phones";
import tablets from "./tablets";

export default [laptops, desktops, phones, tablets];
